<template>
  <div class="columns">
    <div class="column">
      <button class="button" @click="testEmail">Email-test</button>
      <button class="button" @click="seed">Seeda data</button>
      <button class="button" @click="importProjects">Import old projects</button>
      <button class="button" @click="testSignalR">Testa SignalR</button>

      <div v-for="message in testMessageList" :key="message">
        <div>{{ message }}</div>
      </div>

      <button v-if="testMessageList.length > 0" class="button" @click="clearTestMessages">Rensa</button>
      <button class="button" @click="fixInvoiceData">Fixa fakturadata</button>

    </div>
    <div class="column">
      <nerd />
    </div>
  </div>
</template>

<script>

import Nerd from '@/components/fun/Nerd'
import $axios from '@/axios-instance.js'

export default {
  components: {
    Nerd
  },

  data () {
    return {
      testMessageList: []
    }
  },

  methods: {
    testEmail () {
      $axios.get(`${process.env.ROOT_API}/dev/test-email`).then(response => {
        this.$toast(response.data.message, 'success')
      })
    },

    testSignalR () {
      $axios.get(`${process.env.ROOT_API}/dev/test-signalr`).then(response => {
        this.$toast(response.data.message, 'success')
      })
    },

    seed () {
      $axios.get(`${process.env.ROOT_API}/dev/seed`).then(response => {
        this.$toast(response.data.message, 'success')
      })
    },

    importProjects () {
      $axios.get(`${process.env.ROOT_API}/dev/importprojects`).then(response => {
        this.$toast(response.data.message, 'success')
      })
    },

    onTestMessage (message) {
      this.testMessageList.push(message)
    },

    clearTestMessages () {
      this.testMessageList = []
    },

    fixInvoiceData () {
      $axios.get(`${process.env.ROOT_API}/dev/fix-invoices`).then(response => {
        this.$toast(response.data.message, 'success')
      })
    }
  },

  created () {
    this.$messageHub.$on('test-message', this.onTestMessage)
  },

  beforeDestroy () {
    this.$messageHub.$off('test-message', this.onTestMessage)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/DevPageViews/Overview.vue